import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getData, postData } from "../../../../ApiServices/ApiService";
import { ORG_ADD_TEAM, ORG_GET_EMPLOYEE_LIST, ORG_SEARCH_TEAM,ORG_GET_TEAM_LEADER_MANAGER_LIST } from '../../../../ApiServices/BaseURL';
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const ManageTeamsController = (teamList, onRefresh, loading, error) => {
  // //console.log('teamList:-', teamList)
  const { setIsLoginPopup } = useTheme();
  const navigate = useNavigate();
  const [teamListLoading, setTeamListLoading] = useState(false);
  const [teamListError, setTeamListError] = useState(error || '');

  const [teamName, setTeamName] = useState("");
  const [teamLead, setTeamLead] = useState(null); // Dropdown
  const [teamManager, setTeamManager] = useState(null); // Dropdown
  const [group, setGroup] = useState("");
  const teamListRef = useRef(teamList);
  const [manageTeamList, setManageTeamList] = useState([]);
  const [deleteTeamLoading, setDeleteTeamLoading] = useState({});
  const [deleteTeamError, setDeleteTeamError] = useState({});
  const [deleteTeamSuccess, setDeleteTeamSuccess] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const teamInfoRef = useRef(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [teamLeaderLoading, setTeamLeaderLoading] = useState(false);
  const [empError, setEmpError] = useState('');
  const [teamNameError, setTeamNameError] = useState('');
  const [teamLeadError, setTeamLeadError] = useState('');
  const [teamManagerError, setTeamManagerError] = useState('');
  const [filterError, setFilterError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

  
    const pageName = 'ManageTeamsController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

  useEffect(() => {
    // teamListRef.current = teamList;
    setManageTeamList(teamList);

  }, [teamList])
  useEffect(()=>{
    setTeamListError(error)
  },[error])

  useEffect(() => {
    fetchTeamLeaderList()
    fetchManagersList()
  }, [])

  
  const[leaderLoading, setLeaderLoading]=  useState(false);
      const [leaderList, setLeaderList] = useState([]);
      const [leaderFiletrError,setLeaderFilterError] = useState('')
  const fetchTeamLeaderList = async () => {
    try {
      setLeaderLoading(true);
      setLeaderList([]);
      setLeaderFilterError('');
      setEmpError('');
      setEmployeeList([]);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const response = await getData(`${ORG_GET_TEAM_LEADER_MANAGER_LIST}?emp_role=${'TEAM_LEAD'}&emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const filterData = responseData?.dataJ.map(service => ({
                label: service?.emp_name,
                value: service?.emp_id
              }));
              setLeaderList(filterData);
            } else {
              setLeaderFilterError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchYeamLeaderList", responseData?.info || '');
            }
          } else {
            setLeaderFilterError(responseData?.info || 'Failed to fetch User data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchYeamLeaderList", responseData?.info || '');
          }
        } else {
          setLeaderFilterError(responseData?.info || 'Failed to fetch User data.');
          logFrontendException(storedUserId, pageName, "fetchYeamLeaderList", responseData?.info || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setLeaderFilterError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchYeamLeaderList", response || '');
        } else {
          setLeaderFilterError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "fetchYeamLeaderList", response || '');
        }
        setIsLoginPopup(true)
      } else {
        setLeaderFilterError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchYeamLeaderList", response || '');
      }
    } catch (error) {
      if (error.response) {
        setLeaderFilterError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
      } else if (error.request) {
        setLeaderFilterError('No response received from the server. Please check your network connection and try again.');
      } else {
        setLeaderFilterError(`Failed to fetch User data. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchYeamLeaderList-catch", error || '');
      }
    } finally {
      setLeaderLoading(false);
    }
  }


  const[managerLoading, setManagerLoading]=  useState(false);
      const [managerList, setManagerList] = useState([]);
      const [managerFiletrError,setManagerFilterError] = useState('');
      const fetchManagersList = async () => {
        try {
            setManagerLoading(true);
            setEmpError('');
            setManagerList([]);
            setManagerFilterError('');
  
  
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
  
            // Make the API call
            const response = await getData(`${ORG_GET_TEAM_LEADER_MANAGER_LIST}?emp_role=${'TEAM_MANAGER'}&emp_id_auth=${storedUserInfo?.emp_id}`);
            // const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();
  
            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service?.emp_name,
                                value: service?.emp_id
                            }));
                            setManagerList(filterData);
                        } else {
                          setManagerFilterError(responseData?.info || 'Data Not Found');
                          logFrontendException(storedUserId, pageName, "fetchManagersList", responseData?.info || '');
                        }
                    } else {
                      setManagerFilterError(responseData?.info || 'Failed to fetch User data. Please try again.');
                      logFrontendException(storedUserId, pageName, "fetchManagersList", responseData?.info || '');
                    }
                } else {
                  setManagerFilterError(responseData?.info || 'Failed to fetch User data. Status code error.');
                  logFrontendException(storedUserId, pageName, "fetchManagersList", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                  setManagerFilterError('Unauthorized access. Your session may have expired. Please log in again.');
                  logFrontendException(storedUserId, pageName, "fetchManagersList", response || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                  setManagerFilterError(responseData?.info || 'Bad request. Please check the request parameters.');
                  logFrontendException(storedUserId, pageName, "fetchManagersList", response || '');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
           
            // Unexpected or network-related errors
            else {
              setManagerFilterError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "fetchManagersList", response || '');
            }
        } catch (error) {
            // Handle various error scenarios
            
                // An error occurred in setting up the request
                setManagerFilterError(`Failed to fetch User data. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "fetchManagersList-catch", error || '');
            
        } finally {
          setManagerLoading(false);
        }
    }

  const handleCreateTeam = () => {
    //console.log('handleCreateTeam ')
    navigate('/manage-team-details', { state: { selTeamInfo: null } })
  }

  const handleEditTeam = (team, isEdit) => {
    // //console.log('handleEditTeam team editicon', team)
    // navigate('/manage-team-details', {state : { selTeamInfo:team,isEdit: isEdit} });
    navigate('/manage-team-details', { state: { selTeamInfo: team, isEdit: isEdit, selectedTab: 1 } });
  }

  const getStatusStyle = (status) => {
    switch (status) {
      // case "Incomplete":
      //   return { backgroundColor: "rgba(226, 177, 51, 0.18)", color: "rgba(223, 165, 16, 1)" }; // Green
      case 0:
        return { backgroundColor: "rgba(238, 32, 28, 0.18)", color: "rgba(238, 32, 28, 1)" }; // Yellow
      case 1:
        return { backgroundColor: "rgba(26, 147, 46, 0.18)", color: "rgba(26, 147, 46, 1)" }; // Red
      default:
        return {};
    }
  };
  const handleDeleteTeam = (team) => {
    // //console.log('handleDeleteTeam team @', team);
    // showConfirmation(team);
    teamInfoRef.current = team;
    setIsDeleteModalOpen(true);
  }

  const showConfirmation = (team) => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    if (confirmed) {
      callDeleteTeam(team);
    } else {
      //console.log("Delete canceled");
    }
  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
};

const OnAddUpdateSucess = () => {
  onRefresh();
  setFilterError('');
  setTeamListError('');
  setFilters({
    team_name: '',
    team_leader: null,
    team_manager: null
  });
}

const [deletedMessages, setDeletedMessages] = useState([]);
  const callDeleteTeam = async (team) => {
    try {
      //console.log('callDeleteTeam team', team);
      setDeleteTeamError({});
      setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: '' }));
      setDeleteTeamLoading((prev) => ({ ...prev, [team?.team_id]: true }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "team_id": team?.team_id,
        "action": "delete_team"
      }

      //console.log('callDeleteTeam payload', payLoad);

      // Make the API call
      const response = await postData(ORG_ADD_TEAM, payLoad);
      const responseData = await response.json();
      //console.log('callDeleteTeam response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setDeleteTeamSuccess((prev) => ({ ...prev, [team?.team_id]: responseData?.info }));
            setDeletedMessages((prevDeleted) => [...prevDeleted, team?.team_id]);
            setTimeout(() => {
              setDeleteTeamSuccess((prev) => ({ ...prev, [team?.team_id]: '' }));
              OnAddUpdateSucess();
              setCurrentPage(1);
            }, 3000);
          } else {
            setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: responseData?.info || 'Failed to delete team. Please try again.' }));
            logFrontendException(storedUserId, pageName, "callDeleteTeam", responseData?.info || '');
          }
        } else {
          setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: responseData?.info || 'Failed to delete team. Please try again...' }));
          logFrontendException(storedUserId, pageName, "callDeleteTeam", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
          logFrontendException(storedUserId, pageName, "callDeleteTeam", response || '');
        } else {
          // setError(responseData?.info || 'Bad request. Please check the request parameters.');
          setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: responseData?.info || 'Bad request. Please check the request parameters.' }));
          logFrontendException(storedUserId, pageName, "callDeleteTeam", response || '');
        }
      }
      // Internal Server Error: 500
      
      // Unexpected or network-related errors
      else {
        setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: 'Unexpected error occurred. Please try again later.' }));
        logFrontendException(storedUserId, pageName, "callDeleteTeam", response || '');
      }
    } catch (error) {
      
        setDeleteTeamError((prev) => ({ ...prev, [team?.team_id]: `Failed to delete team. Please check your network connection and try again.` }));
        logFrontendException(storedUserId, pageName, "callDeleteTeam-catch", error || '');
      
    } finally {
      setDeleteTeamLoading((prev) => ({ ...prev, [team?.team_id]: false }));
    }
  }

  const handleCreateTeamModal = () => {
    navigate('/manage-team-details', { state: { selTeamInfo: null, isEdit: null, selectedTab: 1, isAddTeam: true } });
    // setIsModalOpen(true); // Open the modal
  };
  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const [filters, setFilters] = useState({
    team_name: '',
    team_leader: null,
    team_manager: null
  });

  const handleFilterChange = (name, value) => {
    //console.log('name : ', name, 'value : ', value)
    setFilterError('');
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const applyFilters = () => {
    //console.log('Applying filters:', filters);
    // setTeamNameError('');
    // setTeamLeadError('');
    // setTeamManagerError('');
    // if(!filters?.team_name){
    //   setTeamNameError('Please enter team name');return
    // }
    // if(!filters?.team_leader){
    //   setTeamLeadError('Please select team leader');return
    // }
    // if(!filters?.team_manager){
    //   setTeamManagerError('Please select team manager');return
    // }
    fetchSearchTeamList();
  };

  const resetFilters = () => {
    if (filters?.team_name.trim() || filters?.team_leader || filters?.team_manager) {
      onRefresh();
      setCurrentPage(1);
    }
    setFilterError('');
    setTeamListError('');
    setFilters({
      team_name: '',
      team_leader: null,
      team_manager: null
    });
    setManagerFilterError('');
    setTeamLeadError('');
    setDeleteTeamError({});
  };

  const cancelFilters = () => {
    resetFilters();
    setShowFilters(!showFilters);
  }

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const fetchSearchTeamList = async () => {
    try {
      setDeleteTeamError({});
      setFilterError('');
      if (!(filters?.team_name.trim() || filters?.team_leader || filters?.team_manager)) {
        setFilterError('Please enter/select any one of the above'); return
      }
      setTeamListLoading(true);
      setTeamListError('');

      // teamListRef.current = [];
      setManageTeamList([]);
      setCurrentPage(1);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      const payLoad={
        "emp_id_auth": storedUserInfo?.emp_id,
        "team_name": filters?.team_name,
        "emp_id_team_lead": filters?.team_leader?.value || 0,
        "emp_id_team_manager": filters?.team_manager?.value || 0,
      }
      //console.log('---team status:---',payLoad);

      const response = await postData(ORG_SEARCH_TEAM,payLoad);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // teamListRef.current = responseData?.dataJ;
              setManageTeamList(responseData?.dataJ);
            } else {
              setTeamListError(responseData?.info || 'No Teams Available');
              logFrontendException(storedUserId, pageName, "fetchSearchTeamList", responseData?.info || '');
            }
          } else {
            setTeamListError(responseData?.info || 'Failed to fetch team list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchSearchTeamList", responseData?.info || '');
          }
        } else {
          setTeamListError(responseData?.info || 'Failed to fetch team list.');
          logFrontendException(storedUserId, pageName, "fetchSearchTeamList", responseData?.info || '');
        }
      }
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setTeamListError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchSearchTeamList", response || '');
        } else {
          setTeamListError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "fetchSearchTeamList", response || '');
        }
      }
      
      else {
        setTeamListError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchSearchTeamList", response || '');
      }
    } catch (error) {
      
        setTeamListError(`Failed to fetch team list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchSearchTeamList-catch", error || '');
      
    } finally {
      setTeamListLoading(false);  
    }
  }

  // const activeTeamList = manageTeamList?.length > 0 ? manageTeamList : teamList;
  const totalPages = Math.ceil(manageTeamList?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPageTeams = manageTeamList?.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
    }
    };

    const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();

  return {
    teamListLoading, teamListError,
    teamName, setTeamName, teamNameError,
    teamManager, setTeamManager, teamManagerError,
    teamLead, setTeamLead, teamLeadError,
    employeeList, teamLeaderLoading,
    group, setGroup,
    teamListRef,
    manageTeamList,
    handleCreateTeam,
    handleEditTeam,
    getStatusStyle,
    handleDeleteTeam,
    deleteTeamLoading,
    deleteTeamError,
    handleCreateTeamModal,
    handleCloseModal,
    isModalOpen,
    showFilters,
    isDeleteModalOpen,
    handleCloseDeleteModal,
    callDeleteTeam,
    teamInfoRef,
    filterError,
    filters,
    handleFilterChange,
    applyFilters, resetFilters, cancelFilters,
    toggleFilters,
    currentPage,
    totalPages,
    handlePageChange,
    currentPageTeams,
    deleteTeamSuccess,

    managerFiletrError,
    managerList,
    managerLoading,
    deletedMessages,
    visiblePages,
    leaderLoading,
    leaderList,
    leaderFiletrError
  }

}

export default ManageTeamsController;